import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PerformanceResultsWidget from '../../../widgets/progressReportSubprojectWidget/PerformanceResultsWidget'
import './styles.less'
import ProgressReportWidget from '../../../widgets/progressReportSubprojectWidget/ProgressReportWidget'
import PlansNextPhaseWidget from '../../../widgets/progressReportSubprojectWidget/PlansNextPhaseWidget'
import OutcomesWidget from '../../../widgets/progressReportSubprojectWidget/OutcomesWidget'
import ObstaclesAndRisksWidget from '../../../widgets/progressReportSubprojectWidget/ObstaclesAndRisksWidget'
import FollowerCommentsWidget from '../../../widgets/progressReportSubprojectWidget/FollowerCommentsWidget'
import { Message, Panel } from 'rsuite'
import IntroductionSubprojectClose from '../../../widgets/progressReportSubprojectWidget/IntroductionSubprojectClose'
import { doneLoading, startLoading } from '../../../utils/loading'
import { getProgressReportSubprojectClose } from '../../../redux/actions/progressReportSubproject'
import PdfRenderWidgets from '../../../widgets/pdfWidgets/PdfRenderWidgets'
import { RETRY_CONTACT_ADMIN } from '../../../constants/msgText'
import { getProgressReportPdf } from '../../../redux/actions/subProjectFinancialReport'

export default function ProgressReportSubprojectClose(props) {
  const [isLoading, setIsLoading] = useState(false)
  const [schemas, setSchemas] = useState()
  const [error, setError] = useState()
  const [progressReportsId, setProgressReportsId] = useState()

  const [isPdfError, setIsPdfError] = useState(false)
  const [previewPdf, setPreviewPdf] = useState()
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)

  const projectId = sessionStorage.getItem('projectId')
  let installmentPlanId = sessionStorage.getItem('param')?.substring(1)

  //กรณีภาคี
  const mockSchema = {
    header: 'รายงานความก้าวหน้างวดปิด',
    isRole: 'THP-xxxx',
    subHeader: 'ข้อเสนอโครงการ เด็กฉลาด ขอเบิกงวดเงิน',
    message: {
      type: 'warning',
      desc: 'กรณีมีส่งกลับมาให้แก้ไข : XXXXXXXXXXXX',
    },
    forms: {
      performanceResults: {
        header: '1. ผลการดำเนินงาน',
        objective: {
          header: 'วัตถุประสงค์',
          input: {
            targetedResult: {
              name: 'targetedResult',
              label: 'ผลลัพธ์ที่ตั้งไว้',
              disable: true,
              value: '',
              hint: 'ผลลัพธ์ที่ตั้งไว้',
              validators: [
                { type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอกผลลัพธ์ที่ตั้งไว้' },
              ],
            },
            actualResults: {
              name: 'actualResults',
              label: 'ผลลัพธ์ที่เกิดขึ้นจริง (หลังจากดำเนินกิจกรรม)',
              disable: false,
              value: '',
              hint: 'ผลลัพธ์ที่เกิดขึ้นจริง (หลังจากดำเนินกิจกรรม)',
              validators: [
                {
                  type: 'REQUIRED',
                  value: null,
                  errorMessage: 'กรุณากรอกผลลัพธ์ที่เกิดขึ้นจริง (หลังจากดำเนินกิจกรรม)',
                },
              ],
            },
            button: {
              disable: false,
              text: 'บันทึก',
            },
          },
          values: [
            {
              objective: {
                id: 'xxxxx-xxxxx-xxxx1',
                label:
                  'พัฒนาเครือข่าย Spiritual Influencer นักสื่อสารสุขภาวะทางปัญญา ขับเคลื่อนอย่างเป็นรูปธรรม ในหลากหลายวงการ หน่วยงาน องค์กร ชุมชน',
              },
              targetedResult: {
                id: 'xxxxx-xxxxxxx-xxxxx1',
                value: '',
              },
              actualResults: {
                id: 'xxxxx-xxxxxxx-xxxxx1',
                value: '',
              },
            },
            {
              objective: {
                id: 'xxxxx-xxxxx-xxxx2',
                label:
                  'เพื่อสร้างพื้นที่การเรียนรู้สุขภาวะทางปัญญาออนไลน์ และออฟไลน์ ให้เกิดการพัฒนาศักยภาพสู่การนำไปใช้ได้จริงอย่างยั่งยืน',
              },
              targetedResult: {
                id: 'xxxxx-xxxxxxx-xxxxx2',
                value: '',
              },
              actualResults: {
                id: 'xxxxx-xxxxxxx-xxxxx2',
                value: '',
              },
            },
            {
              objective: {
                id: 'xxxxx-xxxxx-xxxx3',
                label:
                  'เพื่อสื่อสารสร้างความตระหนักถึงความสำคัญ และเรียนรู้สุขภาวะทางปัญญา สู่สังคมในวงกว้าง',
              },
              targetedResult: {
                id: 'xxxxx-xxxxxxx-xxxxx3',
                value: '',
              },
              actualResults: {
                id: 'xxxxx-xxxxxxx-xxxxx3',
                value: '',
              },
            },
          ],
          changesObjectives: {
            //กรณีงวดสุดท้าย
            name: 'changesObjectives',
            label: 'การเปลี่ยนแปลงที่เกิดขึ้นนอกเหนือวัตถุประสงค์',
            disable: false,
            value: '',
            hint: 'การเปลี่ยนแปลงที่เกิดขึ้นนอกเหนือวัตถุประสงค์',
            validators: [
              {
                type: 'REQUIRED',
                value: null,
                errorMessage: 'กรุณากรอกการเปลี่ยนแปลงที่เกิดขึ้นนอกเหนือวัตถุประสงค์',
              },
            ],
          },
          sustainabilityCompletion: {
            //กรณีงวดสุดท้าย
            name: 'sustainabilityCompletion',
            label: 'ความต่อเนื่องยั่งยืนหลังจากสิ้นสุดการดำเนินโครงการ',
            disable: false,
            value: '',
            hint: 'ความต่อเนื่องยั่งยืนหลังจากสิ้นสุดการดำเนินโครงการ',
            validators: [
              {
                type: 'REQUIRED',
                value: null,
                errorMessage: 'กรุณากรอกความต่อเนื่องยั่งยืนหลังจากสิ้นสุดการดำเนินโครงการ',
              },
            ],
          },
        },
        resultsOfOperations: {
          header: 'ผลการดำเนินการ (กิจกรรม)',
          activities: [
            {
              id: 'xxxxx-xxxxx-xxxx-xxx1',
              input: {
                name: 'activities',
                label: 'กิจกรรมที่ 1 Oneness Connect : Spiritual Influencer Network',
                disable: false,
                value:
                  '1เชิญชวนรวบรวม Influencer ที่เป็นนักสื่อสารสุขภาวะทางปัญญาและจิตวิญญาณ ทั้งที่เป็นนักสื่อสารเดิมที่โครงการ We Oneness สร้างเครือข่ายไว้แล้ว และนักสื่อสารรุ่นใหม่ มาร่วมเครือข่าย Spiritual Influencer นักสื่อสารสุขภาวะทางปัญญา ',
                hint: 'รายละเอียดกิจกรรม',
                validators: [
                  { type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอกรายละเอียดกิจกรรม' },
                ],
              },
              activitiesDetail: [
                {
                  id: 'xxxx-xxxx-xxx-xxx',
                  name: 'activitiesResult',
                  label: 'ผลการดำเนินงาน',
                  disable: false,
                  value: '',
                  activityStartDateInput: {
                    label: 'วันที่เริ่มกิจกรรม',
                    name: 'activityStartDate',
                    disable: false,
                    value: '',
                    validators: [
                      {
                        type: 'REQUIRED',
                        value: null,
                        errorMessage: 'กรุณาระบุวันที่เริ่มกิจกรรม',
                      },
                    ],
                  },
                  activityEndDateInput: {
                    label: 'วันที่สิ้นสุดกิจกรรม',
                    name: 'activityEndDate',
                    disable: false,
                    value: '',
                    validators: [
                      {
                        type: 'REQUIRED',
                        value: null,
                        errorMessage: 'กรุณาระบุวันที่สิ้นสุดกิจกรรม',
                      },
                    ],
                  },
                  locationInput: {
                    label: 'สถานที่จัดกิจกรรม',
                    name: 'locationInput',
                    disable: false,
                    value: '',
                    validators: [
                      // {
                      //   type: 'REQUIRED',
                      //   value: null,
                      //   errorMessage: 'กรุณาระบุสถานที่จัดกิจกรรม',
                      // },
                    ],
                  },
                  targetGroupInput: {
                    label: 'กลุ่มเป้าหมาย',
                    name: 'targetGroupInput',
                    disable: false,
                    value: '',
                    validators: [
                      {
                        type: 'REQUIRED',
                        value: null,
                        errorMessage: 'กรุณาระบุกลุ่มเป้าหมาย',
                      },
                    ],
                  },
                },

                {
                  name: 'activitiesImage',
                  label: 'รูปภาพประกอบกิจกรรม',
                  disable: false,
                  attachFiles: {
                    name: 'attachFiles',
                    header: 'รูปภาพประกอบกิจกรรม',
                    hint: 'รูปภาพประกอบอย่างน้อย 4 รูป',
                    buttonText: 'ไฟล์ประกอบการติดตาม',
                    fileSize: 50,
                    fileType: '.jpg, .jpeg, .png',
                    description: ['รูปภาพประกอบกิจกรรม'],
                    value: [
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                    ],
                    id: null,
                  },
                  attachVideo: {
                    name: 'attachVideo',
                    label: 'Link VDO',
                    attachVideoName: {
                      name: 'attachVideoName',
                      label: 'ชื่อ Video',
                      value: '',
                      validators: [
                        // {
                        //   type: 'REQUIRED',
                        //   value: null,
                        //   errorMessage: 'กรุณากรอกชื่อ Video',
                        // },
                      ],
                    },
                    attachVideoLink: {
                      name: 'attachVideoLink',
                      label: 'Link VDO',
                      value: '',
                      validators: [
                        // {
                        //   type: 'REQUIRED',
                        //   value: null,
                        //   errorMessage: 'กรุณากรอกLink VDO',
                        // },
                      ],
                    },
                    button: {
                      text: 'เพิ่ม',
                    },
                    value: [
                      {
                        seqNo: 1,
                        name: 'ไฟล์ทดสอบ.png',
                        link: 'https://www.youtube.com/watch?v=giKzn07ZrfA',
                      },
                    ],
                  },
                  attachFilesEtc: {
                    name: 'attachFilesEtc',
                    header: 'แนบไฟล์อื่นๆ',
                    hint: 'แนบไฟล์อื่นๆ',
                    buttonText: 'ไฟล์ประกอบการติดตาม',
                    fileSize: 50,
                    fileType: '.jpg, .jpeg, .png',
                    description: ['รูปภาพประกอบกิจกรรม'],
                    value: [
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                    ],
                    id: null,
                  },
                  button: {
                    text: 'บันทึก',
                  },
                },
                {
                  name: 'activitiesBudget',
                  label: 'งบประมาณกิจกรรม',
                  disable: false,
                  noExpenditureOccurredOption: {
                    name: 'noExpenditureOccurredOption',
                    label: 'ไม่มีรายการใช้จ่ายเกิดขึ้น',
                    value: 0,
                    options: [
                      { disabled: false, label: 'ไม่มีรายการใช้จ่ายเกิดขึ้น', value: 0 },
                      // { disabled: false, label: 'มี', value: 1 },
                    ],
                  },
                  income: {
                    name: 'income',
                    title: 'รายรับ',
                    unitText: 'บาท',
                    budgetInput: {
                      name: 'budgetInput',
                      label: 'งบที่ได้รับ',
                      disable: false,
                      value: '1000000.00',
                      hint: 'ระบุงบที่ได้รับ',
                      validators: [
                        // {
                        //   type: 'REQUIRED',
                        //   value: null,
                        //   errorMessage: 'กรุณากรอกงบที่ได้รับ',
                        // },
                      ],
                    },
                  },
                  expenses: {
                    title: 'รายจ่าย',
                    compensationInput: {
                      name: 'compensationInput',
                      buttonInfo: 'ค่าตอบแทนอาสาสมัคร ค่าตอบแทนวิทยากร ค่าตอบแทนประสานงาน',
                      label: 'ค่าตอบแทน',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าตอบแทน',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าตอบแทน',
                        },
                      ],
                    },
                    wagesInput: {
                      name: 'wagesInput',
                      buttonInfo: 'ค่าจ้างจัดทำข้อมูล ค่าจ้างทำของ',
                      label: 'ค่าจ้าง',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าจ้าง',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าจ้าง',
                        },
                      ],
                    },
                    expensesInput: {
                      name: 'expensesInput',
                      buttonInfo:
                        'ค่าใช้จ่ายเพื่อซื้อบริการต่างๆ อาทิ ค่าพาหนะ ค่าที่พัก ค่าถ่ายเอกสาร ค่าเช่าห้องประชุม ค่าอาหารและเครื่องดื่ม ค่าเช่าสถานที่',
                      label: 'ค่าใช้สอย',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าใช้สอย',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าใช้สอย',
                        },
                      ],
                    },
                    materialCostInput: {
                      name: 'materialCostInput',
                      buttonInfo:
                        'ค่าใช้จ่ายเพื่อซื้อวัสดุสิ้นเปลืองในสำนักงานหรือใช้ในการทำกิจกรรม เช่น วัสดุเครื่องเขียนวัสดุสำนักงาน วัสดุโฆษณาและเผยแพร่',
                      label: 'ค่าวัสดุ',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าวัสดุ',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าวัสดุ',
                        },
                      ],
                    },
                    utilityCostsInput: {
                      name: 'utilityCostsInput',
                      buttonInfo: 'ค่าไฟฟ้า ค่าน้ำประปา ค่าโทรศัพท์ ค่าไปรษณีย์ภัณฑ์',
                      label: 'ค่าสาธารณูปโภค',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าสาธารณูปโภค',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าสาธารณูปโภค',
                        },
                      ],
                    },
                    otherValuesInput: {
                      name: 'otherValuesInput',
                      // buttonInfo: 'xxxxx',
                      label: 'ค่าอื่นๆ',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าอื่นๆ',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าอื่นๆ',
                        },
                      ],
                    },
                    totalExpensesInput: {
                      name: 'totalExpensesInput',
                      // buttonInfo: 'xxxxx',
                      label: 'รวมรายจ่าย',
                      disable: false,
                      value: '-200.00',
                      hint: 'ระบุรวมรายจ่าย',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกรวมรายจ่าย',
                        },
                      ],
                    },
                    unitText: 'บาท',
                  },
                  attachFiles: {
                    name: 'attachFiles',
                    header: 'แนบใบเสร็จรับเงิน',
                    // hint: 'รูปภาพประกอบอย่างน้อย 4 รูป',
                    buttonText: 'ไฟล์ประกอบการติดตาม',
                    fileSize: 50,
                    fileType: '.jpg, .jpeg, .png',
                    description: ['แนบใบเสร็จรับเงิน'],
                    validators: [
                      // {
                      //   type: 'REQUIRED',
                      //   value: null,
                      //   errorMessage: 'กรุณากรอกแนบใบเสร็จรับเงิน',
                      // },
                    ],
                    value: [
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                    ],
                    id: null,
                  },
                },
              ],
            },
            {
              id: 'xxxxx-xxxxx-xxxx-xxx2',
              input: {
                name: 'activities',
                label: 'กิจกรรมที่ 2 Oneness Connect : Spiritual Influencer Network',
                disable: false,
                value:
                  '2เชิญชวนรวบรวม Influencer ที่เป็นนักสื่อสารสุขภาวะทางปัญญาและจิตวิญญาณ ทั้งที่เป็นนักสื่อสารเดิมที่โครงการ We Oneness สร้างเครือข่ายไว้แล้ว และนักสื่อสารรุ่นใหม่ มาร่วมเครือข่าย Spiritual Influencer นักสื่อสารสุขภาวะทางปัญญา ',
                hint: 'รายละเอียดกิจกรรม',
                validators: [
                  { type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอกรายละเอียดกิจกรรม' },
                ],
              },
              activitiesDetail: [
                {
                  id: 'xxxx-xxxx-xxx-xxx',
                  name: 'activitiesResult',
                  label: 'ผลการดำเนินงาน',
                  disable: false,
                  value: '',
                  activityStartDateInput: {
                    label: 'วันที่เริ่มกิจกรรม',
                    name: 'activityStartDate',
                    disable: false,
                    value: '',
                    validators: [
                      {
                        type: 'REQUIRED',
                        value: null,
                        errorMessage: 'กรุณาระบุวันที่เริ่มกิจกรรม',
                      },
                    ],
                  },
                  activityEndDateInput: {
                    label: 'วันที่สิ้นสุดกิจกรรม',
                    name: 'activityEndDate',
                    disable: false,
                    value: '',
                    validators: [
                      {
                        type: 'REQUIRED',
                        value: null,
                        errorMessage: 'กรุณาระบุวันที่สิ้นสุดกิจกรรม',
                      },
                    ],
                  },
                  locationInput: {
                    label: 'สถานที่จัดกิจกรรม',
                    name: 'locationInput',
                    disable: false,
                    value: '',
                    validators: [
                      // {
                      //   type: 'REQUIRED',
                      //   value: null,
                      //   errorMessage: 'กรุณาระบุสถานที่จัดกิจกรรม',
                      // },
                    ],
                  },
                  targetGroupInput: {
                    label: 'กลุ่มเป้าหมาย',
                    name: 'targetGroupInput',
                    disable: false,
                    value: '',
                    validators: [
                      {
                        type: 'REQUIRED',
                        value: null,
                        errorMessage: 'กรุณาระบุกลุ่มเป้าหมาย',
                      },
                    ],
                  },
                },

                {
                  name: 'activitiesImage',
                  label: 'รูปภาพประกอบกิจกรรม',
                  disable: false,
                  attachFiles: {
                    name: 'attachFiles',
                    header: 'รูปภาพประกอบกิจกรรม',
                    hint: 'รูปภาพประกอบอย่างน้อย 4 รูป',
                    buttonText: 'ไฟล์ประกอบการติดตาม',
                    fileSize: 50,
                    fileType: '.jpg, .jpeg, .png',
                    description: ['รูปภาพประกอบกิจกรรม'],
                    value: [
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                    ],
                    id: null,
                  },
                  attachVideo: {
                    name: 'attachVideo',
                    label: 'Link VDO',
                    attachVideoName: {
                      name: 'attachVideoName',
                      label: 'ชื่อ Video',
                      value: '',
                      validators: [
                        // {
                        //   type: 'REQUIRED',
                        //   value: null,
                        //   errorMessage: 'กรุณากรอกชื่อ Video',
                        // },
                      ],
                    },
                    attachVideoLink: {
                      name: 'attachVideoLink',
                      label: 'Link VDO',
                      value: '',
                      validators: [
                        // {
                        //   type: 'REQUIRED',
                        //   value: null,
                        //   errorMessage: 'กรุณากรอกLink VDO',
                        // },
                      ],
                    },
                    button: {
                      text: 'เพิ่ม',
                    },
                    value: [
                      {
                        seqNo: 1,
                        name: 'ไฟล์ทดสอบ.png',
                        link: 'https://www.youtube.com/watch?v=giKzn07ZrfA',
                      },
                    ],
                  },
                  attachFilesEtc: {
                    name: 'attachFilesEtc',
                    header: 'แนบไฟล์อื่นๆ',
                    hint: 'แนบไฟล์อื่นๆ',
                    buttonText: 'ไฟล์ประกอบการติดตาม',
                    fileSize: 50,
                    fileType: '.jpg, .jpeg, .png',
                    description: ['รูปภาพประกอบกิจกรรม'],
                    value: [
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                    ],
                    id: null,
                  },
                  button: {
                    text: 'บันทึก',
                  },
                },
                {
                  name: 'activitiesBudget',
                  label: 'งบประมาณกิจกรรม',
                  disable: false,
                  noExpenditureOccurredOption: {
                    name: 'noExpenditureOccurredOption',
                    label: 'ไม่มีรายการใช้จ่ายเกิดขึ้น',
                    value: 0,
                    options: [
                      { disabled: false, label: 'ไม่มีรายการใช้จ่ายเกิดขึ้น', value: 0 },
                      // { disabled: false, label: 'มี', value: 1 },
                    ],
                  },
                  income: {
                    name: 'income',
                    title: 'รายรับ',
                    unitText: 'บาท',
                    budgetInput: {
                      name: 'budgetInput',
                      label: 'งบที่ได้รับ',
                      disable: false,
                      value: '1000000.00',
                      hint: 'ระบุงบที่ได้รับ',
                      validators: [
                        // {
                        //   type: 'REQUIRED',
                        //   value: null,
                        //   errorMessage: 'กรุณากรอกงบที่ได้รับ',
                        // },
                      ],
                    },
                  },
                  expenses: {
                    title: 'รายจ่าย',
                    compensationInput: {
                      name: 'compensationInput',
                      buttonInfo: 'ค่าตอบแทนอาสาสมัคร ค่าตอบแทนวิทยากร ค่าตอบแทนประสานงาน',
                      label: 'ค่าตอบแทน',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าตอบแทน',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าตอบแทน',
                        },
                      ],
                    },
                    wagesInput: {
                      name: 'wagesInput',
                      buttonInfo: 'ค่าจ้างจัดทำข้อมูล ค่าจ้างทำของ',
                      label: 'ค่าจ้าง',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าจ้าง',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าจ้าง',
                        },
                      ],
                    },
                    expensesInput: {
                      name: 'expensesInput',
                      buttonInfo:
                        'ค่าใช้จ่ายเพื่อซื้อบริการต่างๆ อาทิ ค่าพาหนะ ค่าที่พัก ค่าถ่ายเอกสาร ค่าเช่าห้องประชุม ค่าอาหารและเครื่องดื่ม ค่าเช่าสถานที่',
                      label: 'ค่าใช้สอย',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าใช้สอย',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าใช้สอย',
                        },
                      ],
                    },
                    materialCostInput: {
                      name: 'materialCostInput',
                      buttonInfo:
                        'ค่าใช้จ่ายเพื่อซื้อวัสดุสิ้นเปลืองในสำนักงานหรือใช้ในการทำกิจกรรม เช่น วัสดุเครื่องเขียนวัสดุสำนักงาน วัสดุโฆษณาและเผยแพร่',
                      label: 'ค่าวัสดุ',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าวัสดุ',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าวัสดุ',
                        },
                      ],
                    },
                    utilityCostsInput: {
                      name: 'utilityCostsInput',
                      buttonInfo: 'ค่าไฟฟ้า ค่าน้ำประปา ค่าโทรศัพท์ ค่าไปรษณีย์ภัณฑ์',
                      label: 'ค่าสาธารณูปโภค',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าสาธารณูปโภค',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าสาธารณูปโภค',
                        },
                      ],
                    },
                    otherValuesInput: {
                      name: 'otherValuesInput',
                      // buttonInfo: 'xxxxx',
                      label: 'ค่าอื่นๆ',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าอื่นๆ',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าอื่นๆ',
                        },
                      ],
                    },
                    totalExpensesInput: {
                      name: 'totalExpensesInput',
                      // buttonInfo: 'xxxxx',
                      label: 'รวมรายจ่าย',
                      disable: false,
                      value: '-200.00',
                      hint: 'ระบุรวมรายจ่าย',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกรวมรายจ่าย',
                        },
                      ],
                    },
                    unitText: 'บาท',
                  },
                  attachFiles: {
                    name: 'attachFiles',
                    header: 'แนบใบเสร็จรับเงิน',
                    // hint: 'รูปภาพประกอบอย่างน้อย 4 รูป',
                    buttonText: 'ไฟล์ประกอบการติดตาม',
                    fileSize: 50,
                    fileType: '.jpg, .jpeg, .png',
                    description: ['แนบใบเสร็จรับเงิน'],
                    validators: [
                      // {
                      //   type: 'REQUIRED',
                      //   value: null,
                      //   errorMessage: 'กรุณากรอกแนบใบเสร็จรับเงิน',
                      // },
                    ],
                    value: [
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                    ],
                    id: null,
                  },
                },
              ],
            },
          ],
        },
      },
      introduction: {
        header: 'คำนำ',
        subtitle: 'คำนำ',
        introductionInput: {
          name: 'introductionInput',
          label: ' คำนำ',
          value: '',
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณากรอกคำนำ',
            },
          ],
        },
      },
      progress: {
        header: '2. ความก้าวหน้า',
        subtitle:
          'ประเมินความก้าวหน้าของการดำเนินงานโครงการและปัญหาอุปสรรคสำคัญที่มีผลต่อการดำเนินงาน',
        sliderInput: {
          name: 'sliderInput',
          label: 'ประเมินความก้าวหน้าของการดำเนินโครงการ',
          disable: false,
          defaultValue: 50,
          min: 0,
          step: 10,
          max: 100,
          hint: 'รายละเอียดกิจกรรม',
        },
        affectingOperations: {
          title: 'ปัญหาอุปสรรคสำคัญที่มีผลต่อการดำเนินงาน',
          issueInput: {
            name: 'issueInput',
            label: 'ประเด็นปัญหา / อุปสรรค',
            value: '',
            validators: [
              {
                type: 'REQUIRED',
                value: null,
                errorMessage: 'กรุณากรอกประเด็นปัญหา / อุปสรรค',
              },
            ],
          },
          reasonInput: {
            name: 'reasonInput',
            label: 'สาเหตุเพราะ',
            value: '',
            validators: [
              {
                type: 'REQUIRED',
                value: null,
                errorMessage: 'กรุณากรอกสาเหตุเพราะ',
              },
            ],
          },
          solutionsInput: {
            name: 'solutionsInput',
            label: ' แนวทางการแก้ไขของผู้รับทุน',
            value: '',
            validators: [
              {
                type: 'REQUIRED',
                value: null,
                errorMessage: 'กรุณากรอกแนวทางการแก้ไขของผู้รับทุน',
              },
            ],
          },
          values: [
            {
              id: '',
              issue: '',
              reason: '',
              solutions: '',
            },
          ],
        },
      },

      otherOutcomes: {
        header: '3.ผลลัพธ์อื่นๆ',
        subTitle: 'ผลลัพธ์ของโครงการที่สอดคล้องเป้าหมายตัวชี้วัดของแผน',
        fullNameInput: {
          name: 'fullNameInput',
          label: 'ชื่อ - สกุลของแกนนำ',
          value: '',
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณากรอกชื่อ - สกุลของแกนนำ',
            },
          ],
        },
        roleInput: {
          name: 'roleInput',
          label: 'บทบาทหน้าที่',
          value: '',
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณากรอกบทบาทหน้าที่',
            },
          ],
        },

        telephoneInput: {
          name: 'telephoneInput',
          label: 'เบอร์โทรศัพท์',
          value: '',
          validators: [
            // {
            //   type: 'REQUIRED',
            //   value: null,
            //   errorMessage: 'กรุณากรอกเบอร์โทรศัพท์',
            // },
          ],
        },
        email: {
          name: 'email',
          label: 'อีเมล',
          value: '',
          validators: [
            // {
            //   type: 'REQUIRED',
            //   value: null,
            //   errorMessage: 'กรุณากรอกอีเมล',
            // },
          ],
        },
        values: [
          {
            id: '1',
            title: 'แกนนำในด้านการสร้างเสริมสุขภาพในประเด็นต่างๆ',
            name: '',
            role: '',
            province: '',
            address: '',
            telephone: '',
            idCard: '',
          },
        ],
        beneficiary: {
          //กรณีงวดสุดท้าย
          title: '3.1 จำนวนผู้ได้รับผลประโยชน์จากโครงการนี้',
          straightPath: {
            title: 'ผู้ได้รับผลประโยชน์ทางตรง',
            note: 'ผู้ได้รับผลประโยชน์ทางตรง<br />(หมายถึง ผู้ที่มีส่วนร่วมในโครงการ/ผู้ปฏิบัติ/ผู้ลงมือทำ/กลุ่มเป้าหมายหลักของโครงการ)',
            spAmountInput: {
              name: 'spAmountInput',
              label: 'จำนวนผู้ได้รับผลประโยชน์ (คน)',
              value: '',
              validators: [
                {
                  type: 'REQUIRED',
                  value: null,
                  errorMessage: 'กรุณากรอกจำนวนผู้ได้รับผลประโยชน์ (คน)',
                },
              ],
            },
            spHealthPromotingInput: {
              name: 'spHealthPromotingInput',
              label: 'พฤติกรรมที่ส่งเสริมสุขภาพ',
              value: '',
              validators: [
                {
                  type: 'REQUIRED',
                  value: null,
                  errorMessage: 'กรุณากรอกพฤติกรรมที่ส่งเสริมสุขภาพ',
                },
              ],
            },
          },
          indirectWay: {
            title: 'ผู้ได้รับผลประโยชน์ทางอ้อม',
            note: 'ผู้ได้รับผลประโยชน์ทางอ้อม<br />(หมายถึง ผู้ที่ไม่ได้เป็นกลุ่มเป้าหมายที่ลงมือทำแต่ได้รับผลประโยชน์จากที่มีโครงการดังกล่าว)',
            iwAmountInput: {
              name: 'iwAmountInput',
              label: 'จำนวนผู้ได้รับผลประโยชน์ (คน)',
              value: '',
              validators: [
                {
                  type: 'REQUIRED',
                  value: null,
                  errorMessage: 'กรุณากรอกจำนวนผู้ได้รับผลประโยชน์ (คน)',
                },
              ],
            },
            iwHealthPromotingInput: {
              name: 'iwHealthPromotingInput',
              label: 'พฤติกรรมที่ส่งเสริมสุขภาพ',
              value: '',
              validators: [
                {
                  type: 'REQUIRED',
                  value: null,
                  errorMessage: 'กรุณากรอกพฤติกรรมที่ส่งเสริมสุขภาพ',
                },
              ],
            },
          },
        },
        conduciveHealth: {
          //กรณีงวดสุดท้าย
          title: '3.2 สภาพแวดล้อมหรือปัจจัยทางสังคมที่เอื้อต่อสุขภาพ',
          input: {
            detailInput: {
              name: 'detailInput',
              label: 'รายละเอียดสภาพแวดล้อม',
              value: '',
              validators: [
                {
                  type: 'REQUIRED',
                  value: null,
                  errorMessage: 'กรุณากรอกรายละเอียดสภาพแวดล้อม',
                },
              ],
            },
            environmentalInput: {
              name: 'environmentalInput',
              label: 'ลักษณะสภาพแวดล้อม',
              value: '',
              options: [
                {
                  disabled: false,
                  label:
                    'เกิดกฏ กติกา ระเบียบ หรือมาตรการชุมชน เช่น มาตรการลดละเลิกเหล้าในงานศพ/งานบุญ ข้อตกลงการจัดการขยะ',
                  value: 0,
                },
                {
                  disabled: false,
                  label:
                    'เกิดกลไก ระบบ หรือโครงสร้างชุมชนที่พัฒนาขึ้นใหม่ เช่น กลไกสภาผู้นำ, เกิดกองทุนของชุมชน, ระบบเดือนภัย/ เฝ้าระวังภัยในชุมชน',
                  value: 1,
                },
                {
                  disabled: false,
                  label: 'เกิดต้นแบบ พื้นที่เรียนรู้ หรือแหล่งเรียนรู้ในระดับชุมชน',
                  value: 2,
                },
              ],
              validators: [
                {
                  type: 'REQUIRED',
                  value: null,
                  errorMessage: 'กรุณากรอกลักษณะสภาพแวดล้อม',
                },
              ],
            },
          },
          values: [
            {
              id: '',
              detail: '',
              environmental: 0,
            },
          ],
        },
        healthInnovation: null,
        bestPractice: null,
      },
      obstaclesAndRisks: null,
      followerComments: null,
    },
  }

  // กรณีไม่ใช่ภาคี
  const mockSchema2 = {
    header: 'รายงานความก้าวหน้างวดปิด',
    isRole: 'THP-xxxx',
    subHeader: 'ข้อเสนอโครงการ เด็กฉลาด ขอเบิกงวดเงิน',
    message: {
      type: 'warning',
      desc: 'กรณีมีส่งกลับมาให้แก้ไข : XXXXXXXXXXXX',
    },
    forms: {
      performanceResults: {
        header: '1. ผลการดำเนินงาน',
        objective: {
          header: 'วัตถุประสงค์',
          input: {
            targetedResult: {
              name: 'targetedResult',
              label: 'ผลลัพธ์ที่ตั้งไว้',
              disable: true,
              value: '',
              hint: 'ผลลัพธ์ที่ตั้งไว้',
              validators: [
                { type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอกผลลัพธ์ที่ตั้งไว้' },
              ],
            },
            actualResults: {
              name: 'actualResults',
              label: 'ผลลัพธ์ที่เกิดขึ้นจริง (หลังจากดำเนินกิจกรรม)',
              disable: false,
              value: '',
              hint: 'ผลลัพธ์ที่เกิดขึ้นจริง (หลังจากดำเนินกิจกรรม)',
              validators: [
                {
                  type: 'REQUIRED',
                  value: null,
                  errorMessage: 'กรุณากรอกผลลัพธ์ที่เกิดขึ้นจริง (หลังจากดำเนินกิจกรรม)',
                },
              ],
            },
            button: {
              disable: false,
              text: 'บันทึก',
            },
          },
          values: [
            {
              objective: {
                id: 'xxxxx-xxxxx-xxxx1',
                label:
                  'พัฒนาเครือข่าย Spiritual Influencer นักสื่อสารสุขภาวะทางปัญญา ขับเคลื่อนอย่างเป็นรูปธรรม ในหลากหลายวงการ หน่วยงาน องค์กร ชุมชน',
              },
              targetedResult: {
                id: 'xxxxx-xxxxxxx-xxxxx1',
                value: '',
              },
              actualResults: {
                id: 'xxxxx-xxxxxxx-xxxxx1',
                value: '',
              },
            },
            {
              objective: {
                id: 'xxxxx-xxxxx-xxxx2',
                label:
                  'เพื่อสร้างพื้นที่การเรียนรู้สุขภาวะทางปัญญาออนไลน์ และออฟไลน์ ให้เกิดการพัฒนาศักยภาพสู่การนำไปใช้ได้จริงอย่างยั่งยืน',
              },
              targetedResult: {
                id: 'xxxxx-xxxxxxx-xxxxx2',
                value: '',
              },
              actualResults: {
                id: 'xxxxx-xxxxxxx-xxxxx2',
                value: '',
              },
            },
            {
              objective: {
                id: 'xxxxx-xxxxx-xxxx3',
                label:
                  'เพื่อสื่อสารสร้างความตระหนักถึงความสำคัญ และเรียนรู้สุขภาวะทางปัญญา สู่สังคมในวงกว้าง',
              },
              targetedResult: {
                id: 'xxxxx-xxxxxxx-xxxxx3',
                value: '',
              },
              actualResults: {
                id: 'xxxxx-xxxxxxx-xxxxx3',
                value: '',
              },
            },
          ],
          changesObjectives: {
            //กรณีงวดสุดท้าย
            name: 'changesObjectives',
            label: 'การเปลี่ยนแปลงที่เกิดขึ้นนอกเหนือวัตถุประสงค์',
            disable: false,
            value: '',
            hint: 'การเปลี่ยนแปลงที่เกิดขึ้นนอกเหนือวัตถุประสงค์',
            validators: [
              {
                type: 'REQUIRED',
                value: null,
                errorMessage: 'กรุณากรอกการเปลี่ยนแปลงที่เกิดขึ้นนอกเหนือวัตถุประสงค์',
              },
            ],
          },
          sustainabilityCompletion: {
            //กรณีงวดสุดท้าย
            name: 'sustainabilityCompletion',
            label: 'ความต่อเนื่องยั่งยืนหลังจากสิ้นสุดการดำเนินโครงการ',
            disable: false,
            value: '',
            hint: 'ความต่อเนื่องยั่งยืนหลังจากสิ้นสุดการดำเนินโครงการ',
            validators: [
              {
                type: 'REQUIRED',
                value: null,
                errorMessage: 'กรุณากรอกความต่อเนื่องยั่งยืนหลังจากสิ้นสุดการดำเนินโครงการ',
              },
            ],
          },
        },
        resultsOfOperations: {
          header: 'ผลการดำเนินการ (กิจกรรม)',
          activities: [
            {
              id: 'xxxxx-xxxxx-xxxx-xxx1',
              input: {
                name: 'activities',
                label: 'กิจกรรมที่ 1 Oneness Connect : Spiritual Influencer Network',
                disable: false,
                value:
                  '1เชิญชวนรวบรวม Influencer ที่เป็นนักสื่อสารสุขภาวะทางปัญญาและจิตวิญญาณ ทั้งที่เป็นนักสื่อสารเดิมที่โครงการ We Oneness สร้างเครือข่ายไว้แล้ว และนักสื่อสารรุ่นใหม่ มาร่วมเครือข่าย Spiritual Influencer นักสื่อสารสุขภาวะทางปัญญา ',
                hint: 'รายละเอียดกิจกรรม',
                validators: [
                  { type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอกรายละเอียดกิจกรรม' },
                ],
              },
              activitiesDetail: [
                {
                  id: 'xxxx-xxxx-xxx-xxx',
                  name: 'activitiesResult',
                  label: 'ผลการดำเนินงาน',
                  disable: false,
                  value: '',
                  activityStartDateInput: {
                    label: 'วันที่เริ่มกิจกรรม',
                    name: 'activityStartDate',
                    disable: false,
                    value: '',
                    validators: [
                      {
                        type: 'REQUIRED',
                        value: null,
                        errorMessage: 'กรุณาระบุวันที่เริ่มกิจกรรม',
                      },
                    ],
                  },
                  activityEndDateInput: {
                    label: 'วันที่สิ้นสุดกิจกรรม',
                    name: 'activityEndDate',
                    disable: false,
                    value: '',
                    validators: [
                      {
                        type: 'REQUIRED',
                        value: null,
                        errorMessage: 'กรุณาระบุวันที่สิ้นสุดกิจกรรม',
                      },
                    ],
                  },
                  locationInput: {
                    label: 'สถานที่จัดกิจกรรม',
                    name: 'locationInput',
                    disable: false,
                    value: '',
                    validators: [
                      // {
                      //   type: 'REQUIRED',
                      //   value: null,
                      //   errorMessage: 'กรุณาระบุสถานที่จัดกิจกรรม',
                      // },
                    ],
                  },
                  targetGroupInput: {
                    label: 'กลุ่มเป้าหมาย',
                    name: 'targetGroupInput',
                    disable: false,
                    value: '',
                    validators: [
                      {
                        type: 'REQUIRED',
                        value: null,
                        errorMessage: 'กรุณาระบุกลุ่มเป้าหมาย',
                      },
                    ],
                  },
                },

                {
                  name: 'activitiesImage',
                  label: 'รูปภาพประกอบกิจกรรม',
                  disable: false,
                  attachFiles: {
                    name: 'attachFiles',
                    header: 'รูปภาพประกอบกิจกรรม',
                    hint: 'รูปภาพประกอบอย่างน้อย 4 รูป',
                    buttonText: 'ไฟล์ประกอบการติดตาม',
                    fileSize: 50,
                    fileType: '.jpg, .jpeg, .png',
                    description: ['รูปภาพประกอบกิจกรรม'],
                    value: [
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                    ],
                    id: null,
                  },
                  attachVideo: {
                    name: 'attachVideo',
                    label: 'Link VDO',
                    attachVideoName: {
                      name: 'attachVideoName',
                      label: 'ชื่อ Video',
                      value: '',
                      validators: [
                        // {
                        //   type: 'REQUIRED',
                        //   value: null,
                        //   errorMessage: 'กรุณากรอกชื่อ Video',
                        // },
                      ],
                    },
                    attachVideoLink: {
                      name: 'attachVideoLink',
                      label: 'Link VDO',
                      value: '',
                      validators: [
                        // {
                        //   type: 'REQUIRED',
                        //   value: null,
                        //   errorMessage: 'กรุณากรอกLink VDO',
                        // },
                      ],
                    },
                    button: {
                      text: 'เพิ่ม',
                    },
                    value: [
                      {
                        seqNo: 1,
                        name: 'ไฟล์ทดสอบ.png',
                        link: 'https://www.youtube.com/watch?v=giKzn07ZrfA',
                      },
                    ],
                  },
                  attachFilesEtc: {
                    name: 'attachFilesEtc',
                    header: 'แนบไฟล์อื่นๆ',
                    hint: 'แนบไฟล์อื่นๆ',
                    buttonText: 'ไฟล์ประกอบการติดตาม',
                    fileSize: 50,
                    fileType: '.jpg, .jpeg, .png',
                    description: ['รูปภาพประกอบกิจกรรม'],
                    value: [
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                    ],
                    id: null,
                  },
                  button: {
                    text: 'บันทึก',
                  },
                },
                {
                  name: 'activitiesBudget',
                  label: 'งบประมาณกิจกรรม',
                  disable: false,
                  noExpenditureOccurredOption: {
                    name: 'noExpenditureOccurredOption',
                    label: 'ไม่มีรายการใช้จ่ายเกิดขึ้น',
                    value: 0,
                    options: [
                      { disabled: false, label: 'ไม่มีรายการใช้จ่ายเกิดขึ้น', value: 0 },
                      // { disabled: false, label: 'มี', value: 1 },
                    ],
                  },
                  income: {
                    name: 'income',
                    title: 'รายรับ',
                    unitText: 'บาท',
                    budgetInput: {
                      name: 'budgetInput',
                      label: 'งบที่ได้รับ',
                      disable: false,
                      value: '1000000.00',
                      hint: 'ระบุงบที่ได้รับ',
                      validators: [
                        // {
                        //   type: 'REQUIRED',
                        //   value: null,
                        //   errorMessage: 'กรุณากรอกงบที่ได้รับ',
                        // },
                      ],
                    },
                  },
                  expenses: {
                    title: 'รายจ่าย',
                    compensationInput: {
                      name: 'compensationInput',
                      buttonInfo: 'ค่าตอบแทนอาสาสมัคร ค่าตอบแทนวิทยากร ค่าตอบแทนประสานงาน',
                      label: 'ค่าตอบแทน',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าตอบแทน',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าตอบแทน',
                        },
                      ],
                    },
                    wagesInput: {
                      name: 'wagesInput',
                      buttonInfo: 'ค่าจ้างจัดทำข้อมูล ค่าจ้างทำของ',
                      label: 'ค่าจ้าง',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าจ้าง',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าจ้าง',
                        },
                      ],
                    },
                    expensesInput: {
                      name: 'expensesInput',
                      buttonInfo:
                        'ค่าใช้จ่ายเพื่อซื้อบริการต่างๆ อาทิ ค่าพาหนะ ค่าที่พัก ค่าถ่ายเอกสาร ค่าเช่าห้องประชุม ค่าอาหารและเครื่องดื่ม ค่าเช่าสถานที่',
                      label: 'ค่าใช้สอย',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าใช้สอย',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าใช้สอย',
                        },
                      ],
                    },
                    materialCostInput: {
                      name: 'materialCostInput',
                      buttonInfo:
                        'ค่าใช้จ่ายเพื่อซื้อวัสดุสิ้นเปลืองในสำนักงานหรือใช้ในการทำกิจกรรม เช่น วัสดุเครื่องเขียนวัสดุสำนักงาน วัสดุโฆษณาและเผยแพร่',
                      label: 'ค่าวัสดุ',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าวัสดุ',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าวัสดุ',
                        },
                      ],
                    },
                    utilityCostsInput: {
                      name: 'utilityCostsInput',
                      buttonInfo: 'ค่าไฟฟ้า ค่าน้ำประปา ค่าโทรศัพท์ ค่าไปรษณีย์ภัณฑ์',
                      label: 'ค่าสาธารณูปโภค',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าสาธารณูปโภค',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าสาธารณูปโภค',
                        },
                      ],
                    },
                    otherValuesInput: {
                      name: 'otherValuesInput',
                      // buttonInfo: 'xxxxx',
                      label: 'ค่าอื่นๆ',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าอื่นๆ',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าอื่นๆ',
                        },
                      ],
                    },
                    totalExpensesInput: {
                      name: 'totalExpensesInput',
                      // buttonInfo: 'xxxxx',
                      label: 'รวมรายจ่าย',
                      disable: false,
                      value: '-200.00',
                      hint: 'ระบุรวมรายจ่าย',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกรวมรายจ่าย',
                        },
                      ],
                    },
                    unitText: 'บาท',
                  },
                  attachFiles: {
                    name: 'attachFiles',
                    header: 'แนบใบเสร็จรับเงิน',
                    // hint: 'รูปภาพประกอบอย่างน้อย 4 รูป',
                    buttonText: 'ไฟล์ประกอบการติดตาม',
                    fileSize: 50,
                    fileType: '.jpg, .jpeg, .png',
                    description: ['แนบใบเสร็จรับเงิน'],
                    validators: [
                      // {
                      //   type: 'REQUIRED',
                      //   value: null,
                      //   errorMessage: 'กรุณากรอกแนบใบเสร็จรับเงิน',
                      // },
                    ],
                    value: [
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                    ],
                    id: null,
                  },
                },
                // {
                //   name: 'addSubActivities',
                //   label: 'เพิ่มกิจกรรมย่อย',
                //   disable: false,
                //   activityNameInput: {
                //     name: 'activityNameInput',
                //     label: 'ชื่อกิจกรรม',
                //     disable: false,
                //     value: 0,
                //     hint: 'ระบุชื่อกิจกรรม',
                //     validators: [
                //       {
                //         type: 'REQUIRED',
                //         value: null,
                //         errorMessage: 'กรุณากรอกชื่อกิจกรรม',
                //       },
                //     ],
                //   },
                //   activityStartDateInput: {
                //     label: 'วันที่เริ่มกิจกรรม',
                //     name: 'activityStartDateInput',
                //     disable: false,
                //     value: '',
                //     hint: 'ระบุวันที่เริ่มกิจกรรม',
                //     validators: [
                //       {
                //         type: 'REQUIRED',
                //         value: null,
                //         errorMessage: 'กรุณาระบุวันที่เริ่มกิจกรรม',
                //       },
                //     ],
                //   },
                //   activityEndDateInput: {
                //     label: 'วันที่ขอจองสิ้นสุด',
                //     name: 'activityEndDateInput',
                //     disable: false,
                //     value: '',
                //     hint: 'ระบุวันที่เริ่มกิจกรรม',
                //     validators: [
                //       {
                //         type: 'REQUIRED',
                //         value: null,
                //         errorMessage: 'กรุณาระบุวันที่เริ่มกิจกรรม',
                //       },
                //     ],
                //   },
                //   activityStartTimeInput: {
                //     label: 'เวลาเริ่มต้น',
                //     name: 'activityStartTimeInput',
                //     disable: false,
                //     value: '',
                //     hint: 'ระบุเวลาเริ่มต้น',
                //     validators: [
                //       {
                //         type: 'REQUIRED',
                //         value: null,
                //         errorMessage: 'กรุณาระบุเวลาเริ่มต้น',
                //       },
                //     ],
                //   },
                //   activityEndTimeInput: {
                //     label: 'เวลาสิ้นสุด',
                //     name: 'activityEndTimeInput',
                //     disable: false,
                //     value: '',
                //     hint: 'ระบุเวลาสิ้นสุด',
                //     validators: [
                //       {
                //         type: 'REQUIRED',
                //         value: null,
                //         errorMessage: 'กรุณาระบุเวลาสิ้นสุด',
                //       },
                //     ],
                //   },
                //   locationInput: {
                //     name: 'locationInput',
                //     label: 'สถานที่จัดกิจกรรม',
                //     disable: false,
                //     value: '',
                //     hint: 'ระบุสถานที่จัดกิจกรรม',
                //     validators: [
                //       {
                //         type: 'REQUIRED',
                //         value: null,
                //         errorMessage: 'กรุณากรอกสถานที่จัดกิจกรรม',
                //       },
                //     ],
                //   },
                //   targetGroupInput: {
                //     name: 'targetGroupInput',
                //     label: 'กลุ่มเป้าหมาย',
                //     disable: false,
                //     value: '',
                //     hint: 'ระบุกลุ่มเป้าหมาย',
                //     validators: [
                //       {
                //         type: 'REQUIRED',
                //         value: null,
                //         errorMessage: 'กรุณากรอกกลุ่มเป้าหมาย',
                //       },
                //     ],
                //   },
                // },
              ],
            },
            {
              id: 'xxxxx-xxxxx-xxxx-xxx2',
              input: {
                name: 'activities',
                label: 'กิจกรรมที่ 2 Oneness Connect : Spiritual Influencer Network',
                disable: false,
                value:
                  '2เชิญชวนรวบรวม Influencer ที่เป็นนักสื่อสารสุขภาวะทางปัญญาและจิตวิญญาณ ทั้งที่เป็นนักสื่อสารเดิมที่โครงการ We Oneness สร้างเครือข่ายไว้แล้ว และนักสื่อสารรุ่นใหม่ มาร่วมเครือข่าย Spiritual Influencer นักสื่อสารสุขภาวะทางปัญญา ',
                hint: 'รายละเอียดกิจกรรม',
                validators: [
                  { type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอกรายละเอียดกิจกรรม' },
                ],
              },
              activitiesDetail: [
                {
                  id: 'xxxx-xxxx-xxx-xxx',
                  name: 'activitiesResult',
                  label: 'ผลการดำเนินงาน',
                  disable: false,
                  value: '',
                  activityStartDateInput: {
                    label: 'วันที่เริ่มกิจกรรม',
                    name: 'activityStartDate',
                    disable: false,
                    value: '',
                    validators: [
                      {
                        type: 'REQUIRED',
                        value: null,
                        errorMessage: 'กรุณาระบุวันที่เริ่มกิจกรรม',
                      },
                    ],
                  },
                  activityEndDateInput: {
                    label: 'วันที่สิ้นสุดกิจกรรม',
                    name: 'activityEndDate',
                    disable: false,
                    value: '',
                    validators: [
                      {
                        type: 'REQUIRED',
                        value: null,
                        errorMessage: 'กรุณาระบุวันที่สิ้นสุดกิจกรรม',
                      },
                    ],
                  },
                  locationInput: {
                    label: 'สถานที่จัดกิจกรรม',
                    name: 'locationInput',
                    disable: false,
                    value: '',
                    validators: [
                      // {
                      //   type: 'REQUIRED',
                      //   value: null,
                      //   errorMessage: 'กรุณาระบุสถานที่จัดกิจกรรม',
                      // },
                    ],
                  },
                  targetGroupInput: {
                    label: 'กลุ่มเป้าหมาย',
                    name: 'targetGroupInput',
                    disable: false,
                    value: '',
                    validators: [
                      {
                        type: 'REQUIRED',
                        value: null,
                        errorMessage: 'กรุณาระบุกลุ่มเป้าหมาย',
                      },
                    ],
                  },
                },

                {
                  name: 'activitiesImage',
                  label: 'รูปภาพประกอบกิจกรรม',
                  disable: false,
                  attachFiles: {
                    name: 'attachFiles',
                    header: 'รูปภาพประกอบกิจกรรม',
                    hint: 'รูปภาพประกอบอย่างน้อย 4 รูป',
                    buttonText: 'ไฟล์ประกอบการติดตาม',
                    fileSize: 50,
                    fileType: '.jpg, .jpeg, .png',
                    description: ['รูปภาพประกอบกิจกรรม'],
                    value: [
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                    ],
                    id: null,
                  },
                  attachVideo: {
                    name: 'attachVideo',
                    label: 'Link VDO',
                    attachVideoName: {
                      name: 'attachVideoName',
                      label: 'ชื่อ Video',
                      value: '',
                      validators: [
                        // {
                        //   type: 'REQUIRED',
                        //   value: null,
                        //   errorMessage: 'กรุณากรอกชื่อ Video',
                        // },
                      ],
                    },
                    attachVideoLink: {
                      name: 'attachVideoLink',
                      label: 'Link VDO',
                      value: '',
                      validators: [
                        // {
                        //   type: 'REQUIRED',
                        //   value: null,
                        //   errorMessage: 'กรุณากรอกLink VDO',
                        // },
                      ],
                    },
                    button: {
                      text: 'เพิ่ม',
                    },
                    value: [
                      {
                        seqNo: 1,
                        name: 'ไฟล์ทดสอบ.png',
                        link: 'https://www.youtube.com/watch?v=giKzn07ZrfA',
                      },
                    ],
                  },
                  attachFilesEtc: {
                    name: 'attachFilesEtc',
                    header: 'แนบไฟล์อื่นๆ',
                    hint: 'แนบไฟล์อื่นๆ',
                    buttonText: 'ไฟล์ประกอบการติดตาม',
                    fileSize: 50,
                    fileType: '.jpg, .jpeg, .png',
                    description: ['รูปภาพประกอบกิจกรรม'],
                    value: [
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                    ],
                    id: null,
                  },
                  button: {
                    text: 'บันทึก',
                  },
                },
                {
                  name: 'activitiesBudget',
                  label: 'งบประมาณกิจกรรม',
                  disable: false,
                  noExpenditureOccurredOption: {
                    name: 'noExpenditureOccurredOption',
                    label: 'ไม่มีรายการใช้จ่ายเกิดขึ้น',
                    value: 0,
                    options: [
                      { disabled: false, label: 'ไม่มีรายการใช้จ่ายเกิดขึ้น', value: 0 },
                      // { disabled: false, label: 'มี', value: 1 },
                    ],
                  },
                  income: {
                    name: 'income',
                    title: 'รายรับ',
                    unitText: 'บาท',
                    budgetInput: {
                      name: 'budgetInput',
                      label: 'งบที่ได้รับ',
                      disable: false,
                      value: '1000000.00',
                      hint: 'ระบุงบที่ได้รับ',
                      validators: [
                        // {
                        //   type: 'REQUIRED',
                        //   value: null,
                        //   errorMessage: 'กรุณากรอกงบที่ได้รับ',
                        // },
                      ],
                    },
                  },
                  expenses: {
                    title: 'รายจ่าย',
                    compensationInput: {
                      name: 'compensationInput',
                      buttonInfo: 'ค่าตอบแทนอาสาสมัคร ค่าตอบแทนวิทยากร ค่าตอบแทนประสานงาน',
                      label: 'ค่าตอบแทน',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าตอบแทน',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าตอบแทน',
                        },
                      ],
                    },
                    wagesInput: {
                      name: 'wagesInput',
                      buttonInfo: 'ค่าจ้างจัดทำข้อมูล ค่าจ้างทำของ',
                      label: 'ค่าจ้าง',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าจ้าง',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าจ้าง',
                        },
                      ],
                    },
                    expensesInput: {
                      name: 'expensesInput',
                      buttonInfo:
                        'ค่าใช้จ่ายเพื่อซื้อบริการต่างๆ อาทิ ค่าพาหนะ ค่าที่พัก ค่าถ่ายเอกสาร ค่าเช่าห้องประชุม ค่าอาหารและเครื่องดื่ม ค่าเช่าสถานที่',
                      label: 'ค่าใช้สอย',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าใช้สอย',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าใช้สอย',
                        },
                      ],
                    },
                    materialCostInput: {
                      name: 'materialCostInput',
                      buttonInfo:
                        'ค่าใช้จ่ายเพื่อซื้อวัสดุสิ้นเปลืองในสำนักงานหรือใช้ในการทำกิจกรรม เช่น วัสดุเครื่องเขียนวัสดุสำนักงาน วัสดุโฆษณาและเผยแพร่',
                      label: 'ค่าวัสดุ',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าวัสดุ',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าวัสดุ',
                        },
                      ],
                    },
                    utilityCostsInput: {
                      name: 'utilityCostsInput',
                      buttonInfo: 'ค่าไฟฟ้า ค่าน้ำประปา ค่าโทรศัพท์ ค่าไปรษณีย์ภัณฑ์',
                      label: 'ค่าสาธารณูปโภค',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าสาธารณูปโภค',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าสาธารณูปโภค',
                        },
                      ],
                    },
                    otherValuesInput: {
                      name: 'otherValuesInput',
                      // buttonInfo: 'xxxxx',
                      label: 'ค่าอื่นๆ',
                      disable: false,
                      value: '0.00',
                      hint: 'ระบุค่าอื่นๆ',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกค่าอื่นๆ',
                        },
                      ],
                    },
                    totalExpensesInput: {
                      name: 'totalExpensesInput',
                      // buttonInfo: 'xxxxx',
                      label: 'รวมรายจ่าย',
                      disable: false,
                      value: '-200.00',
                      hint: 'ระบุรวมรายจ่าย',
                      validators: [
                        {
                          type: 'REQUIRED',
                          value: null,
                          errorMessage: 'กรุณากรอกรวมรายจ่าย',
                        },
                      ],
                    },
                    unitText: 'บาท',
                  },
                  attachFiles: {
                    name: 'attachFiles',
                    header: 'แนบใบเสร็จรับเงิน',
                    // hint: 'รูปภาพประกอบอย่างน้อย 4 รูป',
                    buttonText: 'ไฟล์ประกอบการติดตาม',
                    fileSize: 50,
                    fileType: '.jpg, .jpeg, .png',
                    description: ['แนบใบเสร็จรับเงิน'],
                    validators: [
                      // {
                      //   type: 'REQUIRED',
                      //   value: null,
                      //   errorMessage: 'กรุณากรอกแนบใบเสร็จรับเงิน',
                      // },
                    ],
                    value: [
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                      {
                        seqNo: 1,
                        isUpSeqNo: true,
                        isDownSeqNo: false,
                        label: 'ไฟล์ทดสอบ.png',
                        name: 'ไฟล์ทดสอบ.png',
                        path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                        type: null,
                        size: 0,
                        id: '030CF477-509D-494A-8226-BF870998E63B',
                      },
                    ],
                    id: null,
                  },
                },
              ],
            },
          ],
        },
      },
      introduction: {
        header: 'คำนำ',
        subtitle: 'คำนำ',
        introductionInput: {
          name: 'introductionInput',
          label: ' คำนำ',
          value: '',
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณากรอกคำนำ',
            },
          ],
        },
      },
      progress: {
        header: '2. ความก้าวหน้า',
        subtitle:
          'ประเมินความก้าวหน้าของการดำเนินงานโครงการและปัญหาอุปสรรคสำคัญที่มีผลต่อการดำเนินงาน',
        sliderInput: {
          name: 'sliderInput',
          label: 'ประเมินความก้าวหน้าของการดำเนินโครงการ',
          disable: false,
          defaultValue: 50,
          min: 0,
          step: 10,
          max: 100,
          hint: 'รายละเอียดกิจกรรม',
        },
        affectingOperations: {
          title: 'ปัญหาอุปสรรคสำคัญที่มีผลต่อการดำเนินงาน',
          issueInput: {
            name: 'issueInput',
            label: 'ประเด็นปัญหา / อุปสรรค',
            value: '',
            validators: [
              {
                type: 'REQUIRED',
                value: null,
                errorMessage: 'กรุณากรอกประเด็นปัญหา / อุปสรรค',
              },
            ],
          },
          reasonInput: {
            name: 'reasonInput',
            label: 'สาเหตุเพราะ',
            value: '',
            validators: [
              {
                type: 'REQUIRED',
                value: null,
                errorMessage: 'กรุณากรอกสาเหตุเพราะ',
              },
            ],
          },
          solutionsInput: {
            name: 'solutionsInput',
            label: ' แนวทางการแก้ไขของผู้รับทุน',
            value: '',
            validators: [
              {
                type: 'REQUIRED',
                value: null,
                errorMessage: 'กรุณากรอกแนวทางการแก้ไขของผู้รับทุน',
              },
            ],
          },
          values: [
            {
              id: '',
              issue: '',
              reason: '',
              solutions: '',
            },
          ],
        },
      },

      otherOutcomes: {
        header: '3.ผลลัพธ์อื่นๆ',
        subTitle: 'ผลลัพธ์ของโครงการที่สอดคล้องเป้าหมายตัวชี้วัดของแผน',
        fullNameInput: {
          name: 'fullNameInput',
          label: 'ชื่อ - สกุลของแกนนำ',
          value: '',
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณากรอกชื่อ - สกุลของแกนนำ',
            },
          ],
        },
        roleInput: {
          name: 'roleInput',
          label: 'บทบาทหน้าที่',
          value: '',
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณากรอกบทบาทหน้าที่',
            },
          ],
        },

        telephoneInput: {
          name: 'telephoneInput',
          label: 'เบอร์โทรศัพท์',
          value: '',
          validators: [
            // {
            //   type: 'REQUIRED',
            //   value: null,
            //   errorMessage: 'กรุณากรอกเบอร์โทรศัพท์',
            // },
          ],
        },
        email: {
          name: 'email',
          label: 'อีเมล',
          value: '',
          validators: [
            // {
            //   type: 'REQUIRED',
            //   value: null,
            //   errorMessage: 'กรุณากรอกอีเมล',
            // },
          ],
        },
        values: [
          {
            id: '1',
            title: 'แกนนำในด้านการสร้างเสริมสุขภาพในประเด็นต่างๆ',
            name: '',
            role: '',
            province: '',
            address: '',
            telephone: '',
            idCard: '',
          },
        ],
        beneficiary: {
          //กรณีงวดสุดท้าย
          title: '3.1 จำนวนผู้ได้รับผลประโยชน์จากโครงการนี้',
          straightPath: {
            title: 'ผู้ได้รับผลประโยชน์ทางตรง',
            note: 'ผู้ได้รับผลประโยชน์ทางตรง<br />(หมายถึง ผู้ที่มีส่วนร่วมในโครงการ/ผู้ปฏิบัติ/ผู้ลงมือทำ/กลุ่มเป้าหมายหลักของโครงการ)',
            spAmountInput: {
              name: 'spAmountInput',
              label: 'จำนวนผู้ได้รับผลประโยชน์ (คน)',
              value: '',
              validators: [
                {
                  type: 'REQUIRED',
                  value: null,
                  errorMessage: 'กรุณากรอกจำนวนผู้ได้รับผลประโยชน์ (คน)',
                },
              ],
            },
            spHealthPromotingInput: {
              name: 'spHealthPromotingInput',
              label: 'พฤติกรรมที่ส่งเสริมสุขภาพ',
              value: '',
              validators: [
                {
                  type: 'REQUIRED',
                  value: null,
                  errorMessage: 'กรุณากรอกพฤติกรรมที่ส่งเสริมสุขภาพ',
                },
              ],
            },
          },
          indirectWay: {
            title: 'ผู้ได้รับผลประโยชน์ทางอ้อม',
            note: 'ผู้ได้รับผลประโยชน์ทางอ้อม<br />(หมายถึง ผู้ที่ไม่ได้เป็นกลุ่มเป้าหมายที่ลงมือทำแต่ได้รับผลประโยชน์จากที่มีโครงการดังกล่าว)',
            iwAmountInput: {
              name: 'iwAmountInput',
              label: 'จำนวนผู้ได้รับผลประโยชน์ (คน)',
              value: '',
              validators: [
                {
                  type: 'REQUIRED',
                  value: null,
                  errorMessage: 'กรุณากรอกจำนวนผู้ได้รับผลประโยชน์ (คน)',
                },
              ],
            },
            iwHealthPromotingInput: {
              name: 'iwHealthPromotingInput',
              label: 'พฤติกรรมที่ส่งเสริมสุขภาพ',
              value: '',
              validators: [
                {
                  type: 'REQUIRED',
                  value: null,
                  errorMessage: 'กรุณากรอกพฤติกรรมที่ส่งเสริมสุขภาพ',
                },
              ],
            },
          },
        },
        conduciveHealth: {
          //กรณีงวดสุดท้าย
          title: '3.2 สภาพแวดล้อมหรือปัจจัยทางสังคมที่เอื้อต่อสุขภาพ',
          input: {
            detailInput: {
              name: 'detailInput',
              label: 'รายละเอียดสภาพแวดล้อม',
              value: '',
              validators: [
                {
                  type: 'REQUIRED',
                  value: null,
                  errorMessage: 'กรุณากรอกรายละเอียดสภาพแวดล้อม',
                },
              ],
            },
            environmentalInput: {
              name: 'environmentalInput',
              label: 'ลักษณะสภาพแวดล้อม',
              value: '',
              options: [
                {
                  disabled: false,
                  label:
                    'เกิดกฏ กติกา ระเบียบ หรือมาตรการชุมชน เช่น มาตรการลดละเลิกเหล้าในงานศพ/งานบุญ ข้อตกลงการจัดการขยะ',
                  value: 0,
                },
                {
                  disabled: false,
                  label:
                    'เกิดกลไก ระบบ หรือโครงสร้างชุมชนที่พัฒนาขึ้นใหม่ เช่น กลไกสภาผู้นำ, เกิดกองทุนของชุมชน, ระบบเดือนภัย/ เฝ้าระวังภัยในชุมชน',
                  value: 1,
                },
                {
                  disabled: false,
                  label: 'เกิดต้นแบบ พื้นที่เรียนรู้ หรือแหล่งเรียนรู้ในระดับชุมชน',
                  value: 2,
                },
              ],
              validators: [
                {
                  type: 'REQUIRED',
                  value: null,
                  errorMessage: 'กรุณากรอกลักษณะสภาพแวดล้อม',
                },
              ],
            },
          },
          values: [
            {
              id: '',
              detail: '',
              environmental: 0,
            },
          ],
        },
        healthInnovation: {
          title: '3.3 นวัตกรรมสร้างเสริมสุขภาพ',
          healthInnovationName: {
            name: 'healthInnovationName',
            label: 'ชื่อนวัตกรรม',
            value: '',
            validators: [
              // {
              //   type: 'REQUIRED',
              //   value: null,
              //   errorMessage: 'กรุณากรอกชื่อนวัตกรรม',
              // },
            ],
          },
          healthInnovationNature: {
            name: 'healthInnovationNature',
            label: 'ลักษณะนวัตกรรม',
            value: '',
            options: [
              { disabled: false, label: 'การพัฒนาความรู้ใหม่จากการวิจัย', value: 0 },
              {
                disabled: false,
                label: 'การนำสิ่งที่มีอยู่ในชุมชนอื่นมาปรับใช้ในชุมชนตนเอง',
                value: 1,
              },
              {
                disabled: false,
                label: 'การนำสิ่งที่มีอยู่มาปรับกระบวนทัศน์ใหม่หรือทำด้วยวิธีใหม่',
                value: 2,
              },
              {
                disabled: false,
                label: 'การรื้อฟื้นสิ่งดีๆ ที่เคยมีในชุมชนมาปรับให้สอดคล้องกับสถานการณ์ปัจจุบัน',
                value: 3,
              },
            ],
            validators: [
              // {
              //   type: 'REQUIRED',
              //   value: null,
              //   errorMessage: 'กรุณากรอกลักษณะนวัตกรรม',
              // },
            ],
          },
          healthInnovationDetail: {
            name: 'healthInnovationDetail',
            label: 'รายละเอียดนวัตกรรม',
            value: '',
            validators: [
              // {
              //   type: 'REQUIRED',
              //   value: null,
              //   errorMessage: 'กรุณากรอกรายละเอียดนวัตกรรม',
              // },
            ],
          },
          healthInnovationUtilization: {
            name: 'healthInnovationUtilization',
            label: 'การนำนวัตกรรมไปใช้ประโยชน์',
            value: '',
            validators: [
              // {
              //   type: 'REQUIRED',
              //   value: null,
              //   errorMessage: 'กรุณากรอกการนำนวัตกรรมไปใช้ประโยชน์',
              // },
            ],
          },
          healthInnovationFiles: {
            name: 'healthInnovationFiles',
            label: 'แนบเอกสารประกอบ',
            value: [],
            validators: [
              // {
              //   type: 'REQUIRED',
              //   value: null,
              //   errorMessage: 'แนบเอกสารประกอบ',
              // },
            ],
          },
          values: [
            {
              healthInnovationName: '',
              healthInnovationNature: '',
              healthInnovationDetail: '',
              healthInnovationUtilization: '',
              healthInnovationFiles: [
                {
                  seqNo: 1,
                  isUpSeqNo: true,
                  isDownSeqNo: false,
                  label: 'ไฟล์ทดสอบ.png',
                  name: 'ไฟล์ทดสอบ.png',
                  path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
                  type: null,
                  size: 0,
                  id: '030CF477-509D-494A-8226-BF870998E63B',
                },
              ],
            },
          ],
        },
        bestPractice: {
          title: '3.4. โครงการตัวอย่างที่ดี (Best Practice)',
          bestPracticeDetail: {
            name: 'bestPracticeDetail',
            label: 'อธิบายลักษณะของการเป็นโครงการตัวอย่างที่ดี ',
            value: '',
            validators: [
              {
                type: 'REQUIRED',
                value: null,
                errorMessage: 'กรุณากรอกอธิบายลักษณะของการเป็นโครงการตัวอย่างที่ดี ',
              },
            ],
          },
          isBestPractice: {
            name: 'isBestPractice',
            label: 'เป็นโครงการตัวอย่างที่ดี ',
            value: '',
            options: [
              { disabled: false, label: 'ใช่', value: 0 },
              {
                disabled: false,
                label: 'ไม่ใช่',
                value: 1,
              },
            ],
            validators: [
              {
                type: 'REQUIRED',
                value: null,
                errorMessage: 'กรุณากรอกเป็นโครงการตัวอย่างที่ดี ',
              },
            ],
          },
        },
      },
      obstaclesAndRisks: {
        header: '4. ปัญหา อุปสรรค และความเสี่ยง',
        subTitle: 'การดำเนินงานกิจกรรม/กลุ่มเป้าหมาย/ระยะเวลาดำเนินงาน/งบประมาณ',
        issuesObstaclesInput: {
          name: 'issuesObstaclesInput',
          label: 'ประเด็นปัญหา/อุปสรรค',
          value: '',
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณากรอกประเด็นปัญหา/อุปสรรค',
            },
          ],
        },
        troubleshootingInput: {
          name: 'troubleshootingInput',
          label: 'การแก้ไขปัญหาของผู้รับผิดขอบโครงการ',
          value: '',
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณากรอกการแก้ไขปัญหาของผู้รับผิดขอบโครงการ',
            },
          ],
        },
        feedbackTroubleshootingInput: {
          name: 'feedbackTroubleshootingInput',
          label: 'ข้อเสนอแนะ/การแก้ปัญหาและการเสริมพลังของผู้ติดตาม',
          values: [{ id: '1', feedbackTroubleshooting: '' }],
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณากรอกข้อเสนอแนะ/การแก้ปัญหาและการเสริมพลังของผู้ติดตาม',
            },
          ],
        },
        operationalRisks: {
          header: '4.1 ด้านความเสี่ยงด้านการดำเนินงาน (Operational Risks)',
          input: {
            subHeader: 'ความเสี่ยงการดำเนินงาน',
            structureOption: {
              name: 'structureOption',
              label: 'โครงสร้าง/ระบบ/กลไกการดำเนินงาน',
              value: '',
              options: [
                { disabled: false, label: 'มีประวัติเสี่ยง/ทำคนเดียว', value: 0 },
                {
                  disabled: false,
                  label: 'มีคณะทำงานแต่ไม่ชัดเจน',
                  value: 1,
                },
                {
                  disabled: false,
                  label: 'มีคณะทำงานเป็นทีมงาน',
                  value: 2,
                },
                {
                  disabled: false,
                  label: 'เป็นทีมงาน มีโครงสร้าง และการแบ่งบทบาทหน้าที่ชัดเจน',
                  value: 1,
                },
              ],
              validators: [
                {
                  type: 'REQUIRED',
                  value: null,
                  errorMessage: 'กรุณากรอกโครงสร้าง/ระบบ/กลไกการดำเนินงาน',
                },
              ],
            },
            structurecommentInput: {
              name: 'structurecommentInput',
              label: 'ความคิดเห็น',
              values: '',
              validators: [
                // {
                //   type: 'REQUIRED',
                //   value: null,
                //   errorMessage: 'กรุณากรอกความคิดเห็น',
                // },
              ],
            },
          },
        },
        financialRisks: {
          header: '',
          input: {
            subHeader: 'ศักยภาพและทักษะการเนินงาน  (Financial Risks)',
            expertOption: {
              name: 'expertOption',
              label: 'ทีมงานมีความรู้/ทักษะความเชี่ยวชาญ/ยอมรับ ',
              value: '',
              options: [
                { disabled: false, label: 'ร้อยละ 10-50', value: 0 },
                {
                  disabled: false,
                  label: 'ร้อยละ 51-70',
                  value: 1,
                },
                {
                  disabled: false,
                  label: 'ร้อยละ 71-85',
                  value: 2,
                },
                {
                  disabled: false,
                  label: 'ร้อยละ 86-100',
                  value: 1,
                },
              ],
              validators: [
                {
                  type: 'REQUIRED',
                  value: null,
                  errorMessage: 'กรุณากรอกทีมงานมีความรู้/ทักษะความเชี่ยวชาญ/ยอมรับ ',
                },
              ],
            },
            expertcommentInput: {
              name: 'expertcommentInput',
              label: 'ความคิดเห็น',
              values: '',
              validators: [
                // {
                //   type: 'REQUIRED',
                //   value: null,
                //   errorMessage: 'กรุณากรอกความคิดเห็น',
                // },
              ],
            },
          },
        },
        skills: {
          header: '',
          input: {
            subHeader: 'ศักยภาพและทักษะการเนินงาน',
            resultOption: {
              name: 'resultOption',
              label: 'ผลลัพธ์และผลสำเร็จการดำเนินงาน',
              value: '',
              options: [
                { disabled: false, label: 'ร้อยละ 10-50', value: 0 },
                {
                  disabled: false,
                  label: 'ร้อยละ 51-70',
                  value: 1,
                },
                {
                  disabled: false,
                  label: 'ร้อยละ 71-85',
                  value: 2,
                },
                {
                  disabled: false,
                  label: 'ร้อยละ 86-100',
                  value: 1,
                },
              ],
              validators: [
                {
                  type: 'REQUIRED',
                  value: null,
                  errorMessage: 'กรุณากรอกทีมงานมีความรู้/ทักษะความเชี่ยวชาญ/ยอมรับ ',
                },
              ],
            },
            resultcommentInput: {
              name: 'resultcommentInput',
              label: 'ความคิดเห็น',
              values: '',
              validators: [
                // {
                //   type: 'REQUIRED',
                //   value: null,
                //   errorMessage: 'กรุณากรอกความคิดเห็น',
                // },
              ],
            },
          },
        },
        financialRiskSystem: {
          header: '4.2 ความเสี่ยงด้านการเงิน',
          input: {
            subHeader: '',
            systemOption: {
              name: 'systemOption',
              label: 'ระบบ/กลไก/เครื่องมือจัดการเอกสารการเงิน',
              value: '',
              options: [
                { disabled: false, label: 'ไม่มีเจ้าหน้าที่การเงิน/ระบบ/เครื่องมือ', value: 0 },
                {
                  disabled: false,
                  label: 'ไม่มีเจ้าหน้าที่การเงิน แต่มีเครื่องมือ',
                  value: 1,
                },
                {
                  disabled: false,
                  label: 'ไม่มีเจ้าหน้าที่การเงิน แต่มีระบบ/เครื่องมือ',
                  value: 2,
                },
                {
                  disabled: false,
                  label: 'มีเจ้าหน้าที่การเงิน/ระบบ/เครื่องมือ',
                  value: 1,
                },
              ],
              validators: [
                {
                  type: 'REQUIRED',
                  value: null,
                  errorMessage: 'กรุณากรอกระบบ/กลไก/เครื่องมือจัดการเอกสารการเงิน',
                },
              ],
            },
            systemcommentInput: {
              name: 'systemcommentInput',
              label: 'ความคิดเห็น',
              values: '',
              validators: [
                // {
                //   type: 'REQUIRED',
                //   value: null,
                //   errorMessage: 'กรุณากรอกความคิดเห็น',
                // },
              ],
            },
          },
        },
        spendingMoney: {
          header: '',
          input: {
            subHeader: '',
            spendingMoneyOption: {
              name: 'spendingMoneyOption',
              label: 'การใช้จ่ายเงินชัดเจน/สอดคล้องตามกิจกรรม',
              value: '',
              options: [
                { disabled: false, label: 'ไม่ชัดเจน/ไม่สอดคล้อง/ผิดประเภท', value: 0 },
                {
                  disabled: false,
                  label: 'ชัดเจนบ้าง/ไม่สอดคล้องบ้าง',
                  value: 1,
                },
                {
                  disabled: false,
                  label: 'ชัดเจน/ไม่สอดคล้องเล็กน้อย',
                  value: 2,
                },
                {
                  disabled: false,
                  label: 'ชัดเจน/สอดคล้อง',
                  value: 1,
                },
              ],
              validators: [
                {
                  type: 'REQUIRED',
                  value: null,
                  errorMessage: 'กรุณากรอกการใช้จ่ายเงินชัดเจน/สอดคล้องตามกิจกรรม',
                },
              ],
            },
            spendingMoneycommentInput: {
              name: 'spendingMoneycommentInput',
              label: 'ความคิดเห็น',
              values: '',
              validators: [
                // {
                //   type: 'REQUIRED',
                //   value: null,
                //   errorMessage: 'กรุณากรอกความคิดเห็น',
                // },
              ],
            },
          },
        },
        document: {
          header: '',
          input: {
            subHeader: '',
            documentOption: {
              name: 'documentOption',
              label: 'การเก็บข้อมูล/เอกสารการเงิน/การตรวจสอบ',
              value: '',
              options: [
                { disabled: false, label: 'ไม่ชัดเจน/ไม่สอดคล้อง/ผิดประเภท', value: 0 },
                {
                  disabled: false,
                  label: 'ชัดเจนบ้าง/ไม่สอดคล้องบ้าง',
                  value: 1,
                },
                {
                  disabled: false,
                  label: 'ชัดเจน/ไม่สอดคล้องเล็กน้อย',
                  value: 2,
                },
                {
                  disabled: false,
                  label: 'ชัดเจน/สอดคล้อง',
                  value: 1,
                },
              ],
              validators: [
                {
                  type: 'REQUIRED',
                  value: null,
                  errorMessage: 'กรุณากรอกการเก็บข้อมูล/เอกสารการเงิน/การตรวจสอบ',
                },
              ],
            },
            documentCommentInput: {
              name: 'documentCommentInput',
              label: 'ความคิดเห็น',
              values: '',
              validators: [
                // {
                //   type: 'REQUIRED',
                //   value: null,
                //   errorMessage: 'กรุณากรอกความคิดเห็น',
                // },
              ],
            },
          },
        },
        resultRisks: null,
      },
    },
  }

  useEffect(() => {
    handleGetSchema()
  }, [sessionStorage.getItem('param')?.substring(1)])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getProgressReportSubprojectClose(0, null, null, installmentPlanId)
      if (response) {
        setSchemas(response)
        setProgressReportsId(response.progressReportsId)
      } else {
        setError({})
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetReport = async () => {
      console.log('handleGetReport', schemas)
      // setIsLoading(true)
      setIsPdfError(false)
      setIsLoadingPDF(true)
  
      // console.log(projectCode, period)
  
      try {
        const response = await getProgressReportPdf(schemas.projectCode, schemas.period, schemas.isFinal)
        console.log('response preview pdf', response)
        if (response) {
          setPreviewPdf(response)
          setIsPdfError(false)
        } else {
          setIsPdfError(true)
        }
      } catch (e) {
        console.error('error pdf => ', e)
        setIsPdfError(true)
      }
  
      // doneLoading()
      // setIsLoading(false)
      setIsLoadingPDF(false)
    }

  if (error) {
    return (
      <SidebarProposal isSubProjectDep6>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schemas || isLoading) {
    return (
      <SidebarProposal isSubProjectDep6>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal isSubProjectDep6>
        <ContentHeader header={schemas.header} subHeader={schemas.subHeader} />

        {schemas.message.desc && (
          <>
            <div style={{ marginBottom: 10 }}>
              <Panel shaded bordered bodyFill>
                <Message
                  type={schemas.message.type}
                  description={<div dangerouslySetInnerHTML={{ __html: schemas.message.desc }} />}
                />
              </Panel>
            </div>
          </>
        )}
        {/* คำนำ */}
        {schemas.forms.introduction && (
          <>
            <IntroductionSubprojectClose
              schema={schemas.forms.introduction}
              period={schemas.period}
              projectCode={schemas.projectCode}
              projectVersionId={schemas.projectVersionId}
              installmentPlanId={installmentPlanId}
              progressReportsId={progressReportsId}
              setProgressReportsId={setProgressReportsId}
              disabled={schemas.disabled}
            />
            <br />
          </>
        )}

        {/* ผลการดำเนินงาน */}
        {schemas.forms.performanceResults && (
          <>
            <PerformanceResultsWidget
              schema={schemas.forms.performanceResults}
              isRole={schemas.isRole}
              renderMentionOfmentor={schemas.renderMentionOfmentor}
              period={schemas.period}
              projectCode={schemas.projectCode}
              projectVersionId={schemas.projectVersionId}
              installmentPlanId={installmentPlanId}
              disabled={schemas.disabled}
              progressReportsId={progressReportsId}
              setProgressReportsId={setProgressReportsId}
              isRenderMentionOfmentor={schemas.renderMentionOfmentor}
              projectStartDate={schemas.projectStartDate}
              projectEndDate={schemas.projectEndDate}
            />
            <br />
          </>
        )}

        {/* ความก้าวหน้า */}
        {schemas.forms.progress && (
          <>
            <ProgressReportWidget
              schema={schemas.forms.progress}
              period={schemas.period}
              projectCode={schemas.projectCode}
              projectVersionId={schemas.projectVersionId}
              progressReportsId={progressReportsId}
              setProgressReportsId={setProgressReportsId}
              installmentPlanId={installmentPlanId}
              disabled={schemas.disabled}
            />
            <br />
          </>
        )}

        {/* แผนในงวดถัดไป อันนี้ไม่มีนะ*/}
        {/* {schemas.forms.plansNextPhase && (
          <>
            <PlansNextPhaseWidget schema={schemas.forms.plansNextPhase} />
            <br />
          </>
        )} */}

        {/* ผลลัพธ์อื่นๆ */}
        {schemas.forms.otherOutcomes && (
          <>
            <OutcomesWidget
              schema={schemas.forms.otherOutcomes}
              isRole={schemas.isRole}
              period={schemas?.period}
              projectCode={schemas?.projectCode}
              projectVersionId={schemas?.projectVersionId}
              progressActivityId={progressReportsId}
              setProgressReportsId={setProgressReportsId}
              installmentPlanId={installmentPlanId}
              disabled={schemas.disabled}
            />
            <br />
          </>
        )}

        {/* 5. ปัญหา อุปสรรค และความเสี่ยง */}
        {schemas.forms.obstaclesAndRisks && (
          <>
            <ObstaclesAndRisksWidget
              schema={schemas.forms.obstaclesAndRisks}
              period={schemas.period}
              projectCode={schemas.projectCode}
              projectVersionId={schemas.projectVersionId}
              installmentPlanId={installmentPlanId}
              disabled={schemas.disabled}
              progressReportsId={progressReportsId}
              setProgressReportsId={setProgressReportsId}
            />
            <br />
          </>
        )}

        {/* 6. ความเห็นผู้ติดตาม */}
        {/* {schemas.forms.followerComments && (
          <>
            <FollowerCommentsWidget schema={schemas.forms.followerComments} />
            <br />
          </>
        )} */}

        {isPdfError ? (
          <Message showIcon type="error" description={'ไม่พบไฟล์ PDF  ' + RETRY_CONTACT_ADMIN} />
        ) : (
          <>
            <div>
              {/* {schemas.displayPdf && schemas.isNotReportsProgress != 1 && ( */}
                <PdfRenderWidgets
                  file={previewPdf}
                  isLoading={isLoadingPDF}
                  isShaded={true}
                  onReload={() => handleGetReport()}
                  loadingMessage="กรุณารอสักครู่ ระบบกำลังสร้าง PDF ข้อเสนอโครงการ..."
                  firstExpandToReload
                  isShowbutton={false}
                />
            </div>
          </>
        )}
      </SidebarProposal>
    </>
  )
}
